import { render, staticRenderFns } from "./ModalValidaDuplicado.vue?vue&type=template&id=a1340b98&scoped=true"
import script from "./ModalValidaDuplicado.vue?vue&type=script&lang=js"
export * from "./ModalValidaDuplicado.vue?vue&type=script&lang=js"
import style0 from "./ModalValidaDuplicado.vue?vue&type=style&index=0&id=a1340b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1340b98",
  null
  
)

export default component.exports